import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { StockPill } from "@/components/site/Reveal";
import { useStore } from "@/lib/store";
import { scrollToId } from "@/lib/api";

const LINKS = [
  ["studio", "3D Studio"],
  ["features", "Features"],
  ["almanac", "Recipes"],
  ["specs", "Specs"],
  ["reviews", "Reviews"],
  ["faq", "FAQ"],
];

export const Nav = () => {
  const { stock, initial, openCheckout } = useStore();
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header data-testid="header-navigation" className="fixed inset-x-0 top-0 z-50 border-b border-[#E3D9CD]/70 bg-[#FDFBF7]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)} className="text-sm text-[#4A4543] transition-colors hover:text-[#C85A32]">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span className="hidden sm:inline-flex"><StockPill stock={stock} initial={initial} /></span>
          <button
            data-testid="nav-buy-now-button"
            onClick={openCheckout}
            className="whitespace-nowrap rounded-full bg-[#181615] px-4 py-2.5 text-sm font-semibold sm:px-5 text-[#FDFBF7] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#C85A32]"
          >
            <span className="hidden sm:inline">Buy — </span><span className="sm:hidden">Buy </span>$250
          </button>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen((v) => !v)} className="rounded-full border border-[#E3D9CD] p-2 lg:hidden" aria-label="Menu">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-[#E3D9CD] bg-[#FDFBF7] px-5 py-4 lg:hidden">
          <div className="mb-3 sm:hidden"><StockPill stock={stock} initial={initial} testId="inventory-badge-mobile" /></div>
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`mobile-nav-link-${id}`} onClick={() => go(id)} className="font-display block w-full py-2.5 text-left text-2xl italic">
              {label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
